module.exports = __webpack_public_path__ + "static/media/paygovbackground.0ec15ed0.jpg";